import * as React from 'react'

import Lane from './Lane'
import { Table, THead, Tr, Th, TBody } from 'components/Table'

export default function Lanes({
  lanes,
  isLocked,
}: {
  lanes: Lane[]
  isLocked: boolean
}) {
  return (
    <Table>
      <THead>
        <Tr>
          <Th className="text-left" width="20%">
            Origin
          </Th>
          <Th className="text-left" width="20%">
            Destination
          </Th>
          <Th className="text-left" width="5%">
            ID
          </Th>
          <Th className="text-center" width="5%">
            Miles
          </Th>
          <Th className="text-center" width="5%">
            VOL
          </Th>
          <Th className="text-left" width="7%">
            Equipment
          </Th>
          <Th className="text-center" width="3%">
            Notes
          </Th>
          <Th className="text-center" width="10%">
            Your Rate
          </Th>
          <Th className="text-center" width="7%">
            Capacity
          </Th>
        </Tr>
      </THead>
      <TBody>
        {lanes.map((lane) => (
          <Lane key={lane.id} isLocked={isLocked} {...lane} />
        ))}
      </TBody>
    </Table>
  )
}
